import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { VacationHead } from '../entities/vacation-head';
import { catchError, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class VacationHeadService extends BaseCrudService<VacationHead> {

  public uri = '/api/vacationHead/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance VacationHeadService');
  }

  // === NUEVO MÉTODO DE RECÁLCULO ===
  recalculateHoliday(euId: number, empTypeId: number, empId: string): Observable<any> {
    const url = this.rutaServidor + this.uri + 'recalculate';
    
    let params = new HttpParams()
      .set('euId', euId.toString())
      .set('empTypeId', empTypeId.toString())
      .set('empId', empId);

    this.spinnerService.showAll();

    return this.httpClient.post<any>(url, {}, { params: params })
      .pipe(
        tap(() => {
            this.spinnerService.hideAll();
        }),
        catchError(e => {  
            this.spinnerService.hideAll();
            
            // Validación tradicional para evitar el error de compilación
            let errorMsg = 'Error en el recálculo de vacaciones';
            if (e && e.error && e.error.messages && e.error.messages.length > 0) {
                errorMsg = e.error.messages[0];
            }
            
            this.notificationService.smallBoxError(errorMsg); 
            return Observable.throw(e);
        })
      );
  }

  buildSentence(entity?: VacationHead, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.row ?
          `row${QueryOperator.Contain}${entity.row}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.startDate ?
          `startDate${QueryOperator.Equal}${entity.startDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.keywordPeriod ?
          `keywordPeriod${QueryOperator.Contain}${entity.keywordPeriod}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.status ?
          `status${QueryOperator.Equal}${entity.status}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isTerminated || !entity.isTerminated ?
          `isTerminated${QueryOperator.Equal}${entity.isTerminated}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.terminationDate ?
          `terminationDate${QueryOperator.Equal}${entity.terminationDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.estimatedDate ?
          `estimatedDate${QueryOperator.Equal}${entity.estimatedDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      // query = query.concat(
      //   entity.daysLit ?
      //     `daysLit${QueryOperator.Contain}${entity.daysLit}${QueryOperator.Split}`
      //     : QueryOperator.Empty
      // );
      query = query.concat(
        entity.daysLit && entity.daysLit == 30 ?
          `daysLit${QueryOperator.Equal}${entity.daysLit}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.daysLit && entity.daysLit != 30 ?
          `daysLit${QueryOperator.LessThan}${29}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.daysProgLit && entity.daysProgLit == 30 ?
          `daysProgLit${QueryOperator.Equal}${entity.daysProgLit}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.usedDays ?
          `usedDays${QueryOperator.Contain}${entity.usedDays}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.usedDaysProg ?
          `usedDaysProg${QueryOperator.Contain}${entity.usedDaysProg}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
          `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
        );
      }
      if (entity.employee && entity.employee.id) {
        query = query.concat(
          `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
        );
      }
      if (entity.employeeType && entity.employeeType.id) {
        query = query.concat(
          `employeeType.id${QueryOperator.Equal}${entity.employeeType.id}${QueryOperator.Split}`
        );
      }
      query = query.concat(
        entity.fiscalYear ?
          `fiscalYear${QueryOperator.Contain}${entity.fiscalYear}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }

    this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'fiscalYear');
    return this.httpParams;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/vacation-head.service.ts